/**
 * PostHog Client-side Initialization
 * Runs on app startup (Next.js 15.3+)
 * Provides analytics, session replay, and error tracking
 */

import posthog from 'posthog-js'

// Initialize PostHog only in client-side environments
if (typeof window !== 'undefined') {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_TOKEN || process.env.NEXT_PUBLIC_POSTHOG_KEY || '', {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
    
    // Use SDK defaults for 2026-01-30 (enables error tracking, session replay, web vitals)
    defaults: '2026-01-30',
    
    // Disable automatic pageview capture; we capture manually in PostHogPageView component
    capture_pageview: false,
    
    // Session replay without masking (except passwords)
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true, // Always mask password fields
      },
    },
    
    // Only capture sessions "identified_only" (authenticated users)
    person_profiles: 'identified_only',
  })
  
  // Register super properties that apply to all events
  // Ensures all events include project, env, and auth_state
  posthog.register({
    project: 'medscan',
    env: process.env.NEXT_PUBLIC_APP_ENV || 'dev',
  })
  
  // Initial auth state (updates in components after login)
  posthog.register({
    auth_state: 'anonymous',
  })
}
